import React, {Component} from 'react';
import { Button, FormControl, Row, Col, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import StockStore from '../../stores/StockStore'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import './Stock.css';
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

class StockEditCategoryModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = {data:[] ,deleteShow:false,indexDelete:-1}
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    
  }


  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  getData(){
    let {data} = this.state
    return data
  }

  loadData(){

    let that = this
    
    StockStore.loadCategory(this.props.stockType,function(result) {
      
      that.setState({data: result.data})
    })
  }

  onNewItemClick(){
    let {data} = this.state
    data.push({name:'',stock_type:this.props.stockType,parent_id:0,cat_id:0,edit:true})
    this.setState({data:data})
  }

  onEditItemClick(index){
    let {data} = this.state
    data[index].edit = true
    this.setState({data:data})
  }

  onConfirmCatDelete(){
    let {messages} = this.props
    let {indexDelete,data} = this.state
    let that = this
    if(data[indexDelete].cat_id>0){
      StockStore.deleteCategory(data[indexDelete].cat_id,function(result) {
        
        data.splice(indexDelete,1);  
        that.setState({data:data,deleteShow:false})  
        
      },function(){
        that._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Remove Category Failed, Please Try Again'],
          level: 'error',
          position:'tc'
        });
      })
    }else{
      data.splice(indexDelete,1);  
      that.setState({data:data,deleteShow:false}) 
    }
  }

  onDeleteItemClick(index){
    let {data} = this.state
    let {messages} = this.props
    if(data[index].name==='' ){
      data.splice(index,1);  
      this.setState({data:data})
    }else{
      this.setState({indexDelete:index,deleteShow:true,deleteMsg:messages['Want To Delete Category']+' ['+data[index].name+'] '+messages['Left Out']})
    }
  }

  onItemChange(index,e){
    let {data} = this.state
    data[index].name = e.target.value
    this.setState({data:data})
    
  }

  renderBody() {
    let {data,deleteShow,deleteMsg} = this.state
    let {messages} = this.props
    return (
      
      <div>
        <Modal.Header closeButton>
          <Modal.Title>{messages['Add Category']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="col-md-9">{messages['Category']}</th>
                <th className="col-md-3">{messages['Edit/Delete']}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item,index)=>(
                <tr key={index}>
                <td>
                  <FormControl type="text" value={item.name} 
                  readOnly={item.edit!==undefined?!item.edit:true} 
                  onChange={this.onItemChange.bind(this,index)}
                  className="input-dark" />
                </td>
                <td className="text-center">
                  <Row>                    
                    <Col md={12}>
                    <Button className="btn-danger" onClick={this.onDeleteItemClick.bind(this,index)}>
                      <FontAwesome name='trash' /> {messages['Delete']}
                    </Button>
                    </Col>
                  </Row>  
                </td>
              </tr>
              ))}
             
            </tbody>
          </table>
          <Button className="btn-success" onClick={this.onNewItemClick.bind(this)}>
            <FontAwesome name='plus' /> {messages['Add Item']}
          </Button>
          <NotificationSystem ref="notificationSystem" />
          <ConfirmPopup show={deleteShow} 
            title={messages['Confirm']} 
            message={deleteMsg}
            confirmTitle={messages['Confirm']} 
            onConfirm={this.onConfirmCatDelete.bind(this)}
            onHide={()=>{this.setState({deleteShow:false})}}        
            /> 
        </Modal.Body>
      </div>
    )
  }

  render(){
    let {messages} = this.props
    return (
      <Modal id="newCategoryPopup" bsSize="large" show={this.props.show} onHide={this.props.onHide}>
        {this.renderBody()}        
        <Modal.Footer>
          <Button className="btn-primary" onClick={this.props.onSaveClick}>
            <FontAwesome name='save' /> {messages['Save Product Category']}
          </Button>
          <Button onClick={this.props.onHide}>
            <FontAwesome name='remove' /> {messages['Cancel']}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


StockEditCategoryModal.defaultProps = {
  show: false,
  stockType:''
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockEditCategoryModal}),null,null,{withRef:true},
)(StockEditCategoryModal);




// WEBPACK FOOTER //
// ./src/view/stock/StockEditCategoryModal.js